import { motion } from 'framer-motion';
import { useReducedMotion } from '@/hooks/useReducedMotion';
import { GreetingText } from './GreetingText';
import { StarterButtons } from './StarterButtons';

interface HeroSectionProps {
  collapsed: boolean;
  onStarterSelect: (message: string) => void;
}

export function HeroSection({ collapsed, onStarterSelect }: HeroSectionProps) {
  const reduced = useReducedMotion();

  if (collapsed) {
    return null;
  }

  return (
    <motion.div
      className="relative flex flex-col items-center justify-center min-h-[calc(100vh-64px)] md:min-h-[calc(100vh-64px)] bg-gradient-to-b from-brand-navy via-brand-charcoal to-brand-navy overflow-hidden"
      initial={reduced ? undefined : { opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.8 }}
    >
      {/* Background decorative image */}
      <div className="absolute inset-0 opacity-40">
        <img
          src="https://cdn.prod.website-files.com/6685b27b98911d2b57296782/6685b27b98911d2b5729680e_NightScene%2044_1.jpg"
          alt=""
          className="w-full h-full object-cover"
          loading="eager"
        />
      </div>

      {/* Gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-brand-navy/50 via-brand-charcoal/30 to-brand-navy/60" />

      {/* Content */}
      <div className="relative z-10 flex flex-col items-center gap-10 py-16">
        <GreetingText />
        <StarterButtons onSelect={onStarterSelect} />
      </div>
    </motion.div>
  );
}
